import { useEffect, useState } from "react";
import {
  getDocuments,
  createDocument,
  updateDocument,
  deleteDocument,
} from "../services/admin.document.service";
import DocumentHeader from "../components/document/DocumentHeader";
import DocumentTable from "../components/document/DocumentTable";
import DocumentCreateModal from "../components/document/DocumentCreateModal";
import DocumentEditModal from "../components/document/DocumentEditModal";
import DocumentDeleteModal from "../components/document/DocumentDeleteModal";
import { useToast } from "../context/ToastContext";

export default function Documents() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [openCreate, setOpenCreate] = useState(false);
  const [selected, setSelected] = useState(null);
  const [editTarget, setEditTarget] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [requiredFilter, setRequiredFilter] = useState("all");
  const [multipleFilter, setMultipleFilter] = useState("all");
  const { showToast } = useToast();

  async function loadDocuments() {
    try {
      const data = await getDocuments();
      setDocuments(data);
    } finally {
      setLoading(false);
    }
  }

  async function handleCreate(payload) {
    try {
      console.log("PAYLOAD ENVOYÉ ", payload);
      await createDocument(payload);
      showToast("Document créé avec succès", "success");
      setOpenCreate(false);
      loadDocuments();
    } catch (err) {
      showToast("Erreur lors de la création du document", "error");
      console.error("ERREUR BACK ", err.response?.data);
      alert(JSON.stringify(err.response?.data, null, 2));
    }
  }

  async function handleEditSubmit(id, data) {
    try {
      await updateDocument(id, data);
      showToast("Document mis à jour", "success");
      setEditTarget(null);
      loadDocuments();
    } catch (err) {
      showToast("Erreur lors de la mise à jour", "error");
    }
  }
  async function handleDelete(id) {
    await deleteDocument(id);
    showToast("Document supprimé avec succès", "success");
    setDeleteTarget(null);
    loadDocuments();
  }

  useEffect(() => {
    loadDocuments();
  }, []);

  function handleView(document) {
    setSelected(document);
  }

  const filtered = documents.filter((doc) => {
    const q = search.toLowerCase();

    const matchesSearch = (doc.name || "").toLowerCase().includes(q);

    let matchesRequired = true;
    if (requiredFilter === "true") matchesRequired = doc.isRequired === true;
    if (requiredFilter === "false") matchesRequired = doc.isRequired === false;

    let matchesMultiple = true;
    if (multipleFilter === "true") matchesMultiple = doc.isMultiple === true;
    if (multipleFilter === "false") matchesMultiple = doc.isMultiple === false;

    return matchesSearch && matchesRequired && matchesMultiple;
  });
  if (loading) return <p>Chargement…</p>;

  return (
    <div className="page">
      <DocumentHeader
        total={filtered.length}
        search={search}
        onSearch={setSearch}
        requiredFilter={requiredFilter}
        onRequiredChange={setRequiredFilter}
        multipleFilter={multipleFilter}
        onMultipleChange={setMultipleFilter}
        onAdd={() => setOpenCreate(true)}
        onEdit={(document) => setEditTarget(document)}
      />

      <DocumentTable
        documents={filtered}
        onEdit={(document) => setEditTarget(document)}
        onDelete={(document) => setDeleteTarget(document)}
      />

      <DocumentCreateModal
        open={openCreate}
        onClose={() => setOpenCreate(false)}
        onSubmit={handleCreate}
      />

      <DocumentEditModal
        open={!!editTarget}
        doc={editTarget}
        onClose={() => setEditTarget(null)}
        onSubmit={handleEditSubmit}
      />

      <DocumentDeleteModal
        document={deleteTarget}
        onClose={() => setDeleteTarget(null)}
        onConfirm={handleDelete}
      />
    </div>
  );
}
